import { toast } from "sonner";
import { generateInvoicePdf } from "./invoicePdf";

const fmtINR = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 2 }).format(n || 0);

export const waPhone = (phone) => {
  const d = String(phone || "").replace(/\D/g, "");
  if (d.length === 10) return `91${d}`;
  if (d.length === 11 && d.startsWith("0")) return `91${d.slice(1)}`;
  return d;
};

const invoiceText = (order) =>
  `Hello ${order.store_name}, please find your invoice from G.M. AGENCIES (GM Kridam Foods).\n` +
  `Bill No: ${(order.id || "").slice(0, 8).toUpperCase()}\n` +
  `Amount: ${fmtINR(order.total)} (${order.payment_status === "paid" ? "Paid" : "Credit"})\n` +
  `Thank you for your business!`;

const fallback = (file, order, store) => {
  const url = URL.createObjectURL(file);
  const a = document.createElement("a");
  a.href = url;
  a.download = file.name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 30_000);
  const phone = waPhone(store?.phone);
  const text = encodeURIComponent(`${invoiceText(order)}\n(Invoice PDF attached)`);
  window.open(phone ? `https://wa.me/${phone}?text=${text}` : `https://wa.me/?text=${text}`, "_blank");
  toast.info("Invoice downloaded. Attach it in the WhatsApp chat that just opened.");
};

const nativeShare = (file, order) =>
  navigator.share({ files: [file], title: file.name, text: invoiceText(order) });

export async function shareInvoiceWhatsApp(order, store) {
  const { blob, filename } = await generateInvoicePdf(order, store, { output: "blob" });
  const file = new File([blob], filename, { type: "application/pdf" });
  if (!(navigator.canShare && navigator.canShare({ files: [file] }))) return fallback(file, order, store);
  try {
    await nativeShare(file, order);
  } catch (e) {
    if (e?.name === "AbortError") return;
    if (e?.name === "NotAllowedError") {
      toast("Invoice ready to share", {
        action: { label: "Share now", onClick: () => nativeShare(file, order).catch(() => {}) },
        duration: 15000,
      });
      return;
    }
    fallback(file, order, store);
  }
}
